import { A11yModule } from '@angular/cdk/a11y';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { UiButtonComponent } from '@big-direkt/ui/button';
import { IconBigMediumSchliessen, IconComponent } from '@big-direkt/utils/icons';
import { BreakpointService } from '@big-direkt/utils/shared';
import { TranslocoDirective } from '@jsverse/transloco';
import { NgPopoverRef } from 'ng-overlay-container';
import { type FormCloseOverlayData } from '../../models/form-close-overlay-data.model';

@Component({
    selector: 'big-ui-modal',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './modal-form-close.component.html',
    imports: [A11yModule, IconComponent, TranslocoDirective, UiButtonComponent],
})
export class ModalFormCloseComponent {
    private readonly breakpointService = inject(BreakpointService);

    public readonly isMobile = this.breakpointService.isMobile;
    public readonly popoverRef = inject<NgPopoverRef<FormCloseOverlayData>>(NgPopoverRef);
    public readonly iconClose = IconBigMediumSchliessen;
}
